var Alberta = "Alberta";
var Manitoba = "Manitoba";
var Nunavut = "Nunavut";
var Ontario = "Ontario";
var Quebec = "Quebec";
var Saskatchewan = "Saskatchewan";
var Yukon = "Yukon";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "Columbia Britannica",
	Manitoba: Manitoba,
	"New Brunswick": "Nuovo Brunswick",
	"Newfoundland and Labrador": "Terranova e Labrador",
	"Northwest Territories": "Territori del Nord",
	"Nova Scotia": "Nuova Scozia",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "Isola del Principe Edoardo",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
